import TranslateUtils from '../../i18n/TranslateUtils'
import './report.css'

export const ReportButton = ({handleViewSummary = () => {}}) => {
    const {translateCommons} = TranslateUtils()
    return (
        <button
            className="reportBtn pointer w-full"
            onClick={() => handleViewSummary()}>
            <span>{translateCommons('View Summary')}</span>
            <span className="report-arrow">
                <svg
                    stroke="white"
                    strokeWidth="1"
                    viewBox="0 0 24 24"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    height="2.5em"
                    width="2.5em"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"></path>
                    <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"></path>
                    <path d="M9 17v-5"></path>
                    <path d="M12 17v-1"></path>
                    <path d="M15 17v-3"></path>
                </svg>
            </span>
        </button>
    )
}
